import { LandingAgeRequirement } from '@campaigns/data-access';

export const MIN_AGE: Record<LandingAgeRequirement, number> = {
  [LandingAgeRequirement.Over18]: 18,
  [LandingAgeRequirement.Over21]: 21,
};

/** Oldest age accepted for a date of birth on registration. */
export const MAX_AGE = 110;
